import { render, staticRenderFns } from "./AppPublic.vue?vue&type=template&id=6d245aa2&"
import script from "./AppPublic.vue?vue&type=script&lang=js&"
export * from "./AppPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports